import { Grid, Heading, theme } from '@zappyrent/hundop';
import ConditionalWrap from 'conditional-wrap';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Media from 'react-media';

import { StyledHeadingWrapper } from './DiscoverZappyrent.styles';

const DiscoverZappyrentHeading = (): JSX.Element => {
  const { t } = useTranslation('product');

  return (
    <Media
      queries={{
        mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
        desktop: `(min-width: ${theme.breakpoints.l})`,
      }}
      defaultMatches={{ desktop: true }}
    >
      {matches => (
        <ConditionalWrap
          condition={matches.mobile}
          wrap={children => (
            <>
              <Grid container>{children}</Grid>
            </>
          )}
        >
          <StyledHeadingWrapper>
            <Heading tag="h1" sm="32px" md="56px" lg="56px">
              <Trans
                i18nKey="discoverZappyrent"
                t={t}
                components={{ span: <span /> }}
              />
            </Heading>
          </StyledHeadingWrapper>
        </ConditionalWrap>
      )}
    </Media>
  );
};

export default DiscoverZappyrentHeading;
